/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Group_TherapiesInputs */

const en_service_type_group_therapies = /** @type {(inputs: Service_Type_Group_TherapiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Therapies`)
};

const pl_service_type_group_therapies = /** @type {(inputs: Service_Type_Group_TherapiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terapie i zabiegi`)
};

/**
* | output |
* | --- |
* | "Therapies" |
*
* @param {Service_Type_Group_TherapiesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_group_therapies = /** @type {((inputs?: Service_Type_Group_TherapiesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Group_TherapiesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_group_therapies(inputs)
	return en_service_type_group_therapies(inputs)
});